import React from 'react'

export default ({ content }) => (
  <div className='static-view' dangerouslySetInnerHTML={{ __html: content }} />
)
